export function currencyFormat(amount){
  let formattedCurrency = amount.toString();
  formattedCurrency = formattedCurrency.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return formattedCurrency
}

export function numericalFormat(input){
  let formattedNumber = input.toString();
  formattedNumber = formattedNumber.replace(/\D/g, "");
  formattedNumber = formattedNumber.replace(/^0+/, "");
  return formattedNumber
}